import { CrewLedger } from "../../components/CrewSchedule/CrewLedger";

interface ICrewLedgerWindowProps {
  windowProps: {
    crewId: string;
  };
}

export const CrewLedgerWindow = (props: ICrewLedgerWindowProps): JSX.Element => {
  const { windowProps } = props;
  const { crewId } = windowProps;
  return <CrewLedger crewId={crewId} />;
};
